import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET SALUTATION
// ===================================================================================
export const salutationLoading = () => {
	return {
		type: "SALUTATION_IS_LOADING"
	};
};

export const salutationError = err => {
	return {
		type: "SALUTATION_HAS_ERROR",
		err
	};
};

export const salutationSuccess = data => {
	return {
		type: "SALUTATION_SUCCESS",
		data
	};
};

export function getSalutations() {
	return dispatch => {
		dispatch(salutationLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "salutations", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(salutationError(response.data.errors));
				} else {
					dispatch(salutationSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(salutationError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/salutations.js